import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { PureContentProps } from "./types";

export class PureContentDefinitions extends CmsReactComponent<
    PureContentProps
> {
    static schemaName = "pure-content";

}
